import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsAdd.vue?vue&type=template&id=53a10e3a&scoped=true&"
import script from "./OfficialHolidaysPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a10e3a",
  null
  
)

export default component.exports